


















































import Vue from "vue";
import AgreementService from "@/services/agreementService";
import { File } from "@/models/agreement";
import AdminService from "@/services/adminService";

export default Vue.extend({
  data() {
    return {
      files: [] as File[],
      isLoaded: false,
      deleting: false
    };
  },
  name: "Agreement",

  async created() {
    await this.getList();
  },
  methods: {
    async getList() {
      this.isLoaded = true;
      const jwt = window.localStorage.getItem("jwt");
      if (jwt) {
        const agreementService = new AgreementService(jwt);
        const response = await agreementService.getAgreement();
        if (response && response.status == 200) {
          this.files = response.data.files;
        }
      }
      this.isLoaded = false;
    },
    async deleteAgreement(e, name) {
      e.preventDefault();
      if (this.deleting) {
        return;
      }
      if (confirm("Are you sure you want to delete " + name)) {
        this.isLoaded = true;
        const jwt = window.localStorage.getItem("jwt");
        if (jwt) {
          const adminService = new AdminService(jwt);
          try {
            const formData = new FormData();
            formData.append("name", name.trim());
            const response = await adminService.deleteAgreements(formData);
            if (response && response.status == 200) {
              if (response.data) {
                alert(response.data);
                await this.getList();
                this.isLoaded = false;
              }
            }
          } catch (e) {
            alert(JSON.stringify(e.response.data));
            this.isLoaded = false;
          }
        }
      }
    },
    async goToUploadAgreement() {
      await this.$router.push("/admin-upload-agreement");
    }
  }
});
